<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
  }

  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <!--  Company Name -->
  @if (user?.companyId) {
    <a mat-button [routerLink]="['/company', company?.id]" class="d-lg-flex" [ngClass]="{ 'text-primary': isActiveCompany() }">
      {{ company?.name }}
    </a>
  }

  <div class="d-none d-lg-flex">
    <!-- --------------------------------------------------------------- -->
    <!--  Links -->
    <!-- --------------------------------------------------------------- -->
  </div>

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <!-- <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="d-flex d-lg-none justify-content-center">
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <app-language-dropdown/>

  <!-- --------------------------------------------------------------- -->
  <!-- Theme Toggle -->
  <!-- --------------------------------------------------------------- -->
  <app-theme-toggle (optionsChange)="onThemeChange($event)"/>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-icon-button matBadge="5" [matMenuTriggerFor]="notificationmenu" aria-label="Notifications" class="m-x-5 notification-badge">
    <i-tabler class="d-flex" name="bell"></i-tabler>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow p-0">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div>

    @for (notification of notifications; track notification.title) {
      <button mat-menu-item class="p-x-32 p-y-16">
        <div class="d-flex align-items-center">
          <img [src]="notification.img" class="rounded-circle" width="48" />
          <div class="m-l-16">
            <h5 class="f-s-14 f-w-600 m-0">
              {{ notification.title }}
            </h5>
            <span>{{ notification.subtitle }}</span>
          </div>
        </div>
      </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">See all notifications</button>
    </div>
  </mat-menu> -->

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button [matMenuTriggerFor]="profilemenu" aria-label="Notifications" class="m-l-8 cursor-pointer">
    <!-- <img src="/assets/images/profile/user-1.jpg" class="size-[35px] rounded-full" alt="Rounded avatar" /> -->
    <icon
      icon="user"
      class="size-[35px] text-lg bg-light-primary text-primary rounded-full d-flex justify-content-center align-items-center"
    ></icon>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow p-0">
    <div class="p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">{{ 'user profile' | translate }}</h6>

      <div class="d-flex border-b-1! border-[var(--mat-sys-primary-fixed-dim)] align-items-center p-b-24 m-t-16 cursor-pointer" (click)="navigateToProfile()">
        <icon icon="user" class="!size-20 text-3xl bg-light-primary text-primary rounded d-flex justify-content-center align-items-center" ></icon>
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0">{{ user?.name }}</h6>
          <span class="d-flex align-items-center">
            <i-tabler name="mail" class="icon-15 m-r-4 mt-1"></i-tabler>
            <span>{{ user?.email }}</span>
          </span>
        </div>
      </div>
    </div>
    <div class="p-x-32">
      @for (profile of profiledd; track profile.title) {
        <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light shadow-none rounded">
              <img [src]="profile.img" width="20" />
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                {{ profile.title | translate }}
              </h5>
              <span class="f-s-14 text-body">{{ profile.subtitle | translate }}</span>
            </div>
          </div>
        </a>
      }
    </div>

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100 dark:text-white!" (click)="logout()">
        <div class="d-flex justify-content-center gap-1">
          <icon icon="right-from-bracket" class="text-primary dark:text-white! d-flex justify-content-center align-items-center"></icon>
          <span>{{ 'logout' | translate }}</span>
        </div>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>
